import { SvgIcon, SvgIconProps } from "@mui/material";

export const SeatIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <path
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
        d="M8 13.5V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v8.5M6.5 21A1.5 1.5 0 0 1 8 19.5h8a1.5 1.5 0 0 1 1.5 1.5M12 16.5v3"
      />
      <path
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
        d="M7.5 13.5h9a1 1 0 0 1 1 1v.5a1.5 1.5 0 0 1-1.5 1.5H8A1.5 1.5 0 0 1 6.5 15v-.5a1 1 0 0 1 1-1Z"
        clip-rule="evenodd"
      />
      <path
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
        d="M5.5 9.5H4v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2h-1.5"
      />
    </svg>
  </SvgIcon>
);
